import emUtils from "@/utils/emUtils";

export default {
    methods: {
        $_emGotoMixin_gotoHolderList(holderEntity, filterHolder, entityHolder, isInline, urlParam = {}, queryApi = "findByFilter", customVuexFilter = "filter", customVuexEntity = "entity", routerName) {
            //设置filterHolder
            this.$store.commit(`${holderEntity}/set${emUtils.toCapFirst(customVuexFilter)}Holder`, filterHolder)
            // console.log('设置filterHolder',`${holderEntity}/set${emUtils.toCapFirst(customVuexFilter)}Holder`, filterHolder)
            // console.log('当前filterHolder',this.$store.state[`${holderEntity}`][`${customVuexFilter}Holder`])
            //设置entityHolder
            this.$store.commit(`${holderEntity}/set${emUtils.toCapFirst(customVuexEntity)}Holder`, entityHolder)
            //清空除holder之外的查询条件
            this.$store.dispatch("emBase/emBaseClearFilter", {entity: holderEntity, filterState: customVuexFilter})
                .then(() => {
                    //跳转:判断路由参数inline=1，如果是，跳转时也需要传递该参数
                    if ((this.$route.query.inline && this.$route.query.inline === "1") || isInline) {
                        this.$router.push({
                            name: routerName ? routerName : `${holderEntity}List`,
                            query: Object.assign({pathType: "fromParent", inline: "1"}, urlParam)
                        });
                    } else {
                        this.$router.push({
                            name: routerName ? routerName : `${holderEntity}List`
                            , query: Object.assign({pathType: "fromOtherList"}, urlParam)
                        });
                    }
                }).then(() => {
                // console.log('查询前filterHolder',this.$store.state[`${holderEntity}`][`${customVuexFilter}Holder`])
                this.$store.dispatch("emBase/emBaseQueryByFilter", {entity: holderEntity, customVuexFilter, queryApi})
            })
        },
        $_emGotoMixin_gotoList(entity, fromId, urlParam = {}) {
            let query = Object.assign({pathType: "fromOtherList", fromId}, urlParam)
            this.$router.push({
                name: `${entity}List`,
                query
            });
        }
    }
};
